
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiConnection3Bars as ObiConnection3BarsElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-connection-3-bars.js';
 
 
 

 
 export const ObiConnection3Bars = createComponent({
   react: React,
   tagName: 'obi-connection-3-bars',
   elementClass: ObiConnection3BarsElement,
   events: {
     
   }
  });
 
 